export default {
   "type": "object",
   "required": [

   ],
   "properties": {
      "memberid": {
         "type": "string",
         "title": "Member ID",
         "x-cols": 4,
         "default": ""
      },
      "membertype": {
         "type": "string",
         "title": "Member Type",
         "default": "",
         "x-cols": 4,
         "oneOf": [
            {
               "const": "ASC",
               "title": "Associate Member",
            },
            {
               "const": "STU",
               "title": "Student Member",
            },
            {
               "const": "GRA",
               "title": "Graduate Member",
            },
            {
               "const": "COR",
               "title": "Corporate Member",
            },
            {
               "const": "FEL",
               "title": "Fellow Member",
            },
            {
               "const": "HON",
               "title": "Honorary Member",
            },
            {
               "const": "PAT",
               "title": "Patron",
            },
         ],
      },
      "memberstatus": {
         "type": "number",
         "title": "Membership Status",
         "x-cols": 4,
         "default": "",
         "oneOf": [
            { "const": 0, "title": "Applying" },
            { "const": 1, "title": "Pending Approval" },
            { "const": 2, "title": "Pending Payment" },
            { "const": 3, "title": "Active" },
            { "const": 4, "title": "Suspended" },
            { "const": 5, "title": "Retired" },
            { "const": 6, "title": "Deceased" },
            { "const": 7, "title": "Struck-Off" },
            { "const": 8, "title": "Non-Good Standing" },
         ]
      },

      "lpbmcode": {
         "type": "string",
         "title": "LPBM Code",
         "default": "",
         "x-cols": 4,
         "oneOf": [
            { "const": "A", "title": "A" },
            { "const": "B", "title": "B" },
         ]
      },
      "lpbmno": {
         "type": "string",
         "title": "LPBM No.",
         "x-cols": 8,
         "default": ""
      },
      "dateapplied": {
         "type": "string",
         "title": "Date Applied",
         "default": "",
         "x-cols": 3,
         "x-props": {
            "readonly": true,
         }
      },
      "dateapproved": {
         "type": "string",
         "title": "Date Approved",
         "x-cols": 3,
         "default": "",
         "x-props": {
            "readonly": true,
         }
      },
      "datepayment": {
         "type": "string",
         "title": "Date Payment",
         "x-cols": 3,
         "default": "",
         "x-props": {
            "readonly": true,
         }
      },
      "datevalid": {
         "type": "string",
         "title": "Date Valid",
         "x-cols": 3,
         "default": "",
         "x-props": {
            "readonly": true,
         }
      },
   },
}
